import React from 'react';

import Badge from '@atlaskit/badge';

const BadgeRemovedExample = (): React.JSX.Element => {
	return <Badge appearance="removed">-100</Badge>;
};

export default BadgeRemovedExample;
